import HandbookRegisterModal from './HandbookRegisterModal';

export { HandbookRegisterModal };
export default HandbookRegisterModal;
